import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="careers-dialog"
// Opens the mission overlay as a native modal dialog. The browser handles Esc,
// the focus trap and returning focus to the hero button.
export default class extends Controller {
  static targets = ["dialog"];

  // Wired to turbo:before-cache: Turbo clones the page for its cache before
  // disconnect() runs, so an open dialog would be restored as a broken <dialog open>.
  closeBeforeCache() {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close();
  }

  // Safari does not focus a clicked button, so the dialog would return focus to <body>.
  open(event) {
    event.currentTarget.focus();
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  // A text selection dragged out of the card ends in a click on the dialog
  // itself; only a press that started on the backdrop closes it.
  rememberPress(event) {
    this.pressedBackdrop = event.target === this.dialogTarget;
  }

  closeOnBackdrop(event) {
    if (this.pressedBackdrop && event.target === this.dialogTarget) this.close();
  }
}
